import { config as t } from "../../config/index.es.js";
const s = {
  override: void 0,
  has: function(e) {
    const r = t.featureFlags;
    return this.override !== void 0 ? this.override : !!r && (r[e] === !0 || r[e] === "true");
  }
};
export {
  s as featureFlagsService
};
